import appConfig from '@/configs/app.config'
import { REDIRECT_URL_KEY } from '@/constants/app.constant'
import { Navigate, Outlet, useLocation } from 'react-router'
import { useAuth } from '@/auth'

const { unAuthenticatedEntryPath } = appConfig

const ProtectedRoute = () => {
    const { authenticated, loading } = useAuth()
    const { pathname, search } = useLocation()

    // The query string comes back too: /oauth/authorize carries an app's whole request there.
    const getPathName =
        pathname === '/' || pathname === unAuthenticatedEntryPath
            ? ''
            : `?${REDIRECT_URL_KEY}=${encodeURIComponent(pathname + search)}`

    if (loading) {
        return null
    }

    if (!authenticated) {
        return (
            <Navigate
                replace
                to={`${unAuthenticatedEntryPath}${getPathName}`}
            />
        )
    }

    return <Outlet />
}

export default ProtectedRoute
